export const headerHeight = {
  desktop: 88,
  tablet: 70,
  mobile: 56
};
